__turbopack_context__.v({
  "certificationsContent": "Engagement-module__N0EK1G__certificationsContent",
  "certificationsLogos": "Engagement-module__N0EK1G__certificationsLogos",
  "contentBlock": "Engagement-module__N0EK1G__contentBlock",
  "engagementSection": "Engagement-module__N0EK1G__engagementSection",
  "subtitle": "Engagement-module__N0EK1G__subtitle",
  "title": "Engagement-module__N0EK1G__title",
  "wrapper": "Engagement-module__N0EK1G__wrapper",
});
